import { Nullable } from 'v5/platform/typescript';

/**
 * Layer 2 — browsing scope: list API team filters from resolved app scope (URL).
 * Team-level URLs filter by `enterprise_team_id`; org/workspace URLs do not.
 *
 * @see .cursor/rules/workspace-scoping-layers.mdc
 */

export type TeamScoping = { teamId: Nullable<number> };

export type WithTeamScoping<T> = T & TeamScoping;

export const teamScopingQueryUtils = {
  ofGlobal: (): TeamScoping => ({ teamId: null }),
  ofTeam: (teamId: number): TeamScoping => ({ teamId })
};

export function withTeamScoping<T>(
  searchQuery: T,
  scoping: TeamScoping
): WithTeamScoping<T> {
  return { ...searchQuery, ...scoping };
}
